// extracted by css-extract-rspack-plugin
export default {"footer":"EditForm__footer--p1dQF"};